module.exports = __webpack_public_path__ + "3f8b2aa.v5.1.1.woff2";